/**
 * 
 * 1
 * 
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase"; // Sesuaikan path jika firebase.js berada di lokasi lain


 * Custom hook untuk memeriksa status autentikasi pengguna Firebase.
 * Mengembalikan objek yang berisi:
 * - user: Objek pengguna Firebase jika sudah login, atau null.
 * - loading: Boolean yang menunjukkan apakah proses autentikasi masih berlangsung.

const useAuthCheck = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, []); // Array dependensi kosong berarti efek ini hanya berjalan sekali saat komponen di-mount

    return { user, loading };
};

export default useAuthCheck;
 */

// src/hooks/useAuthCheck.jsx
import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { ref, onValue, off } from "firebase/database"; // Import Firebase DB methods
import { auth, database } from "../firebase"; // Import both auth and database instances

/**
 * Custom hook untuk memeriksa status autentikasi pengguna Firebase dan mengambil data profilnya.
 * Mengembalikan objek yang berisi:
 * - user: Objek pengguna Firebase jika sudah login, atau null.
 * - userProfile: Objek data profil pengguna dari db_user/tb_user jika ditemukan, atau null.
 * - loading: Boolean yang menunjukkan apakah proses autentikasi dan pengambilan profil masih berlangsung.
 */
const useAuthCheck = () => {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null); // State baru untuk profil pengguna
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            if (currentUser) {
                // Jika user login, coba ambil data profilnya
                const userProfileRef = ref(database, `db_user/tb_user/${currentUser.uid}`);
                const unsubscribeProfile = onValue(userProfileRef, (snapshot) => {
                    if (snapshot.exists()) {
                        const profileData = snapshot.val();
                        setUserProfile(profileData);
                        console.log("User profile loaded:", profileData); // Log untuk debugging
                    } else {
                        setUserProfile(null);
                        console.log("User profile not found for UID:", currentUser.uid); // Log jika profil tidak ditemukan
                    }
                    setLoading(false); // Set loading false setelah profil (atau ketiadaannya) diketahui
                }, (error) => {
                    console.error("Error fetching user profile:", error);
                    setUserProfile(null); // Pastikan userProfile null jika ada error
                    setLoading(false); // Set loading false meskipun ada error
                });

                // Cleanup subscription for user profile on unmount or user change
                return () => {
                    unsubscribeProfile();
                };
            } else {
                // Jika user logout, reset userProfile dan set loading false
                setUserProfile(null);
                setLoading(false);
            }
        });

        // Cleanup subscription for auth state on unmount
        return () => unsubscribeAuth();
    }, [database]); // Tambahkan 'database' sebagai dependency karena digunakan di dalam useEffect

    return { user, userProfile, loading }; // Kembalikan userProfile
};

export default useAuthCheck;
